import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StyleRoot } from 'radium';
import { setConfiguration as setReactGridSystemConfiguration } from 'react-grid-system';
import * as LocalizationUtil from '@vp-dst/localization-util';

import Router from 'Router';
import getStore from 'redux/store';
import VistaprintAnalyticsService from 'services/VistaprintAnalyticsService';
import { siteCulture, activeTrackedFeatures } from 'settings/vistaprintContext';
import { responsiveWidthBreakpoints } from 'settings/theme';
import localizedTextData from 'data/localizedText';
import 'index.css';

LocalizationUtil.configure({
    siteCulture,
    localizedTextData,
});

setReactGridSystemConfiguration({
    breakpoints: responsiveWidthBreakpoints,
    containerWidths: responsiveWidthBreakpoints,
});

// records a feature value touched event for any tracked features (see data/trackedFeatures.json) that are active in the current session
activeTrackedFeatures.forEach(feature => VistaprintAnalyticsService.recordFeatureValueTouched(feature.id));

ReactDOM.render(
    <Provider store={getStore()}>
        <StyleRoot>
            <Router />
        </StyleRoot>
    </Provider>,
    document.getElementById('dst-ds-brief-app')
);




// WEBPACK FOOTER //
// ./src/index.js